/**
 * @desc 沃尔玛库存获取
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  params: API.fulfilment.stockSkuPlatform.walmartStockPage.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/stock/platform/walmartStockPage`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
